module.exports = __webpack_public_path__ + "02dcc54d7f6c9dc2dfe53775fdea3980.png";